export default "__VITE_ASSET__07042ead__"